import React from "react";
import SplitText from "./SplitText";
import LitText from "./LitText";
import SectionIntro from "./SectionIntro";
import Reveal from "../Reveal";
import { PHILOSOPHY } from "../../data/about";

/**
 * The page's quiet moment.
 *
 * Almost nothing here: one statement, a short paragraph that lights as it is
 * read, and a single soft glow behind them. After seven sections of
 * composition the restraint is the point — this is what gives the closing
 * call to action room to land, so anything added to it makes it worse.
 */

function Philosophy() {
  return (
    <section
      id="culture"
      className="relative isolate scroll-mt-24 overflow-hidden bg-[#0B0518] py-24 lg:py-32"
    >
      <div className="absolute inset-0" aria-hidden="true">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_72%_62%_at_50%_50%,#2E1065_0%,#12021D_58%,#070110_100%)]" />
        <div className="mw-aurora absolute left-1/2 top-1/2 h-[38rem] w-[38rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#6A0DAD]/22 blur-[140px]" />
        <div className="mw-grain absolute inset-0 opacity-[0.13] mix-blend-overlay" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        <Reveal>
          <SectionIntro index={PHILOSOPHY.index} label={PHILOSOPHY.label} tone="dark" />
        </Reveal>

        <SplitText
          as="p"
          lines={PHILOSOPHY.lines}
          stagger={70}
          className="mw-display mt-10 max-w-4xl text-white"
        />

        {/* Set to the right of the statement, so the block of small text is a
            counterweight rather than a caption. */}
        <div className="mt-14 flex lg:justify-end">
          <LitText
            text={PHILOSOPHY.body}
            className="mw-lede max-w-lg text-white lg:text-right"
          />
        </div>
      </div>
    </section>
  );
}

export default Philosophy;
